import React, { useContext, useState, useEffect, useRef } from "react";
import { Input, Form, Select, Row, Col, Typography } from "antd";
export const defaultOptions = {
  price: {
    currency: ["USD", "INR", "GBP", "EUR", "RMB", "AUD"],
    unit: [
      "per-piece",
      "per-feet",
      "per-inch",
      "per-cm",
      "per-metre",
      "per-1000-metres",
      "per-gram",
      "per-kilogram",
      "per-metric-ton",
      "per sq. feet",
      "per sq. metre",
    ],
  },
};
const { Text } = Typography;
const { Option } = Select;
const RenderFields = ({
  type,
  dataIndex,
  inputRef,
  children,
  save,
  saveComposite,
  updateSubCategory,
  record,
  defaults,
  toggleEdit,
  form,
}) => {
  const isComposite = dataIndex.split("_").length > 1;
  const isProductCost = dataIndex.includes("Product Cost");

  const compositeObj = {
    price: {
      currency: isProductCost ? (
        <span ref={inputRef}>{children}</span>
      ) : (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
        >
          <Select
            ref={inputRef}
            // onBlur={save}
            // onPressEnter={save}
            onChange={save}
            defaultOpen={true}
            // defaultValue={record[dataIndex]}
          >
            {defaultOptions.price.currency.map(
              (item, index) =>
                item && (
                  <Option key={`${index}${item}`} value={item}>
                    {item}
                  </Option>
                )
            )}
          </Select>
        </Form.Item>
      ),
      unit: isProductCost ? (
        <span ref={inputRef}>{children}</span>
      ) : (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
        >
          <Select
            ref={inputRef}
            // onBlur={save}
            // onPressEnter={save}
            onChange={save}
            defaultOpen={true}
            // defaultValue={record[dataIndex]}
          >
            {defaultOptions.price.unit.map(
              (item, index) =>
                item && (
                  <Option key={`${index}${item}`} value={item}>
                    {item}
                  </Option>
                )
            )}
          </Select>
        </Form.Item>
      ),
    },
    size: {
      unit: (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
        >
          <Select
            ref={inputRef}
            onPressEnter={(value) => {
              saveComposite(value, dataIndex, "unit");
            }}
            defaultOpen={true}
            onChange={(value) => {
              saveComposite(value, dataIndex, "unit");
            }}
          >
            {["cms", "inches"].map(
              (item, index) =>
                item && (
                  <Option key={`${index}${item}`} value={item}>
                    {item}
                  </Option>
                )
            )}
          </Select>
        </Form.Item>
      ),
    },
  };
  const componentsObj = {
    text: (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
      >
        <Input ref={inputRef} onBlur={save} onPressEnter={save} />
      </Form.Item>
    ),
    csv:
      dataIndex.toLowerCase() === "sub category" ? (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
        >
          <Select
            mode="tags"
            ref={inputRef}
            onBlur={save}
            defaultOpen={true}
            // onPressEnter={(e) =>
            //   updateSubCategory(e?.target?.value, record.product_id)
            // }
            // onChange={(e) => updateSubCategory(e, record.product_id)}
            notFoundContent={
              <Text type="secondary">Start typing to add...</Text>
            }
          >
            {defaults?.sub_category?.map(
              (item, index) =>
                item && (
                  <Option key={`${index}${item}`} value={item}>
                    {item}
                  </Option>
                )
            )}
          </Select>
        </Form.Item>
      ) : (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
        >
          <Select
            mode="tags"
            ref={inputRef}
            onBlur={save}
            defaultOpen={true}
            onPressEnter={save}
            // onChange={save}
            notFoundContent={
              <Text type="secondary">Start typing to add...</Text>
            }
          >
            {defaults?.[dataIndex]?.map(
              (item, index) =>
                item && (
                  <Option key={`${index}${item}`} value={item}>
                    {item}
                  </Option>
                )
            )}
          </Select>
        </Form.Item>
      ),
    price: isProductCost ? (
      <span ref={inputRef}>{children}</span>
    ) : (
      <Form.Item
        style={{ marginBottom: "0" }}
        name={dataIndex}
        // onClick={toggleEdit}
      >
        <Input
          ref={inputRef}
          onBlur={save}
          onPressEnter={save}
          value={record[dataIndex]}
          type="number"
          onWheel={(e) => e.currentTarget.blur()}
        />
      </Form.Item>
    ),
    size: (
      <Row
        ref={inputRef}
        style={{ maxHeight: "32px" }}
        justify="space-between"
        gutter={[6]}
      >
        <Col>
          <Form.Item name={`${dataIndex}_length`} style={{ width: "55px" }}>
            <Input
              onChange={(e) => {
                form.setFieldsValue({
                  [`${dataIndex}_length`]: e.target.value,
                });
              }}
              onBlur={(e) => {
                saveComposite(e.target.value, dataIndex, "length");
              }}
              type="number"
              onWheel={(e) => e.currentTarget.blur()}
              // onPressEnter={(e) => {
              //   saveComposite(e.target.value, dataIndex, "length");
              // }}
            />
          </Form.Item>
        </Col>
        <Col style={{ marginTop: "6px" }}>X</Col>
        <Col>
          <Form.Item name={`${dataIndex}_width`} style={{ width: "60px" }}>
            <Input
              onBlur={(e) => {
                saveComposite(e.target.value, dataIndex, "width");
              }}
              onChange={(e) => {
                form.setFieldsValue({
                  [`${dataIndex}_width`]: e.target.value,
                });
              }}
              type="number"
              onWheel={(e) => e.currentTarget.blur()}
              // onPressEnter={(e) => {
              //   saveComposite(e.target.value, dataIndex, "width");
              // }}
            />
          </Form.Item>
        </Col>
        <Col style={{ marginTop: "6px" }}>X</Col>
        <Col>
          <Form.Item name={`${dataIndex}_height`} style={{ width: "60px" }}>
            <Input
              onBlur={(e) => {
                saveComposite(e.target.value, dataIndex, "height");
              }}
              onChange={(e) => {
                form.setFieldsValue({
                  [`${dataIndex}_height`]: e.target.value,
                });
              }}
              type="number"
              onWheel={(e) => e.currentTarget.blur()}
              // onPressEnter={(e) => {
              //   saveComposite(e.target.value, dataIndex, "height");
              // }}
            />
          </Form.Item>
        </Col>
      </Row>
    ),
    textarea: (
      <Form.Item name={dataIndex}>
        <Input.TextArea ref={inputRef} onBlur={save} onPressEnter={save} />
      </Form.Item>
    ),
    // select: (
    //   <Select size="large" onChange={save}>
    //     {defaultValues && defaultValues?.select?.length > 0
    //       ? defaultValues?.select?.map((item, index) => (
    //           <Option key={`${index}${item}`} value={item}>
    //             {item}{" "}
    //           </Option>
    //         ))
    //       : null}
    //   </Select>
    // ),
  };
  return isComposite
    ? compositeObj[type][dataIndex.split("_")[1]]
    : componentsObj[type] || (
        <Input ref={inputRef} onBlur={save} onPressEnter={save} />
      );
};

export default RenderFields;
